import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { typeSafeObjectEntries, typeSafeObjectFromEntries, } from "../../../utils/helpers";
import { sortMethods, sortOptions, } from "../../../utils/sorting";
import { isValidOverlayKey, } from "../components/overlay/Overlay";
const settings = {
    disableChatPopup: {
        title: "Prevent mod-triggered card pop-ups",
        type: "boolean",
        process: (value) => !!value,
        configurable: true,
    },
    disableCardEffects: {
        title: "Disable 3D card effects",
        type: "boolean",
        process: (value) => !!(value !== null && value !== void 0 ? value : window.matchMedia("(prefers-reduced-motion: reduce)").matches),
        configurable: true,
    },
    ambassadorSort: {
        title: "Sort cards by",
        type: "select",
        options: sortOptions,
        process: (value) => sortMethods.includes(value) ? value : "default",
        configurable: true,
    },
    disableOverlayHiding: {
        title: "(DEV) Prevent app hiding automatically",
        type: "boolean",
        process: (value) => process.env.NODE_ENV === "development" && !!value,
        configurable: process.env.NODE_ENV === "development",
    },
    forceBirthdayEffects: {
        title: "(DEV) Force birthday effects",
        type: "boolean",
        process: (value) => process.env.NODE_ENV === "development" && !!value,
        configurable: process.env.NODE_ENV === "development",
    },
    openedMenu: {
        title: "Menu that was last opened",
        type: "string",
        process: (value) => isValidOverlayKey(value) ? value : "ambassadors",
        configurable: false,
    },
};
const Context = createContext(undefined);
export const SettingsProvider = ({ children }) => {
    const [stored, setStored] = useState(() => {
        // Load settings from local storage on mount, merging with defaults
        const storage = JSON.parse(localStorage.getItem("settings") || "{}");
        return typeSafeObjectEntries(settings).reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value.process(storage[key]) })), {});
    });
    // Save settings to local storage when they change
    useEffect(() => {
        localStorage.setItem("settings", JSON.stringify(stored));
    }, [stored]);
    // Change the value of a setting
    const change = useCallback((key, value) => {
        setStored((current) => (Object.assign(Object.assign({}, current), { [key]: value })));
    }, []);
    // Expose a full object for the settings
    const obj = useMemo(() => typeSafeObjectFromEntries(typeSafeObjectEntries(settings).map(([key, value]) => [
        key,
        Object.assign(Object.assign({}, value), { value: stored[key], change: (value) => change(key, value) }),
    ])), [stored, change]);
    return _jsx(Context, { value: obj, children: children });
};
const useSettings = () => {
    const ctx = useContext(Context);
    if (!ctx)
        throw new Error("useSettings must be used within a SettingsProvider");
    return ctx;
};
export default useSettings;
